export { DisplayText, type DisplayTextProps } from './DisplayText';
